export enum AnswerStatus {
  notAnswered = 0,
  correct = 1,
  incorrect = 2,
  skipped = 3,
}

export function replace(input: string) {
  const replaceWithHTMLCodeTag = (input: string) => {
    return input.replace(/`([^`]+)`/g, '<code class="inline">$1</code>');
  };

  const replaceWithHTMLStrongTag = (input: string) => {
    return input.replace(/\*\*([^*]+)\*\*/g, "<b>$1</b>");
  };

  const replaceWithHTMLItalicTag = (input: string) => {
    return input.replace(/_([^*]+)_/g, "<i>$1</i>");
  };

  const replaceWithSeparatorTag = (input: string) => {
    return input.replace(/\/\//g, "<br>");
  };

  return replaceWithHTMLCodeTag(
    replaceWithSeparatorTag(
      replaceWithHTMLStrongTag(replaceWithHTMLItalicTag(input))
    )
  );
}

export function arraysAreEqual(arr1: string[], arr2: string[]): boolean {
  if (arr1.length !== arr2.length) {
    return false;
  }

  const sortedArr1 = [...arr1].sort();
  const sortedArr2 = [...arr2].sort();

  for (let i = 0; i < sortedArr1.length; i++) {
    if (sortedArr1[i] !== sortedArr2[i]) {
      return false;
    }
  }

  return true;
}
